<template>
  <section class="sec02">
    <div class="inner">
      <!--바로가기 버튼-->
      <div class="shortcut">
        <div class="btn_wrap">
          <div class="shortcut_btn left">
            <button class="combine" @click="fnMove(1)">
              <span>위생교육<br />홈페이지</span>
              <div class="cv_next"></div>
            </button>
          </div>
          <div class="shortcut_btn right">
            <button class="combine" @click="fnMove(2)">
              <!-- <span>외식경영<br />관리사</span> -->
              <span style="font-size: 25px;">음식점업 <br />고용허가제(E-9)<br />사업주 사전 교육</span>
              <div class="cv_next"></div>
            </button>
          </div>
        </div>
      </div>
      <!--//바로가기 버튼-->
      <!--로그인-->
      <sign-in :is-page="false" v-if="$Util.isEmpty(userData)" />
      <!--//로그인-->
    </div>
  </section>
</template>

<script>
import SignIn from '@/components/pages/sign/in/index'

export default {
  name: 'main-contents-index',
  components: { SignIn },
  computed: {
    userData() {
      return this.$store.getters['user/getUserData']
    }
  },
  methods: {
    fnMove: function(type = 1) {
      if (type === 1) {
        // 교육 홈페이지 메인으로 이동
        location.href='https://kfoodedu.or.kr/main'
      } else {
        // 외식 경영 관리자 안내 페이지로 이동
        // this.$router.push({ path: '/manager/info'})
        // 음식점업 고용허가제(E-9) 사업주 사전 교육 페이지로 이동 (서남아이에스 임현아, 2024-07-22)
        location.href='https://kofsia-e9.liveklass.com'
      }
    }
  }
}
</script>

<style scoped></style>
